import { Mail, Settings, ClipboardList } from "lucide-react"

function UserProfile({ email, name, image, userType }) {


  return (
    <div className="max-w-sm mx-auto bg-white rounded-lg shadow-sm overflow-hidden border border-gray-100">
      <div className="px-6 pt-6 pb-4">
        <div className="flex items-center">
          <img
            className="h-20 w-20 rounded-full object-cover border border-gray-100"
            src={image || "/placeholder.svg?height=128&width=128"}
            alt={`Avatar of ${name}`}
          />
          <div className="ml-4">
            <h1 className="text-xl font-medium text-gray-900">{name}</h1>
            <span className="inline-block text-sm text-gray-500">{userType}</span>
          </div>
        </div>

        <div className="mt-6 flex items-center text-gray-600">
          <Mail className="h-4 w-4 text-gray-400" />
          <span className="ml-2 text-sm">{email}</span>
        </div>
      </div>

      <div className="px-6 pb-6">
        <button className="w-full bg-black text-white px-4 py-2 rounded-md hover:bg-gray-800 transition-colors text-sm font-medium">
          Editar Perfil
        </button>
      </div>

      <div className="border-t border-gray-100">
        <div className="grid grid-cols-2">
          <button className="flex items-center justify-center py-3 text-sm text-gray-600 hover:bg-gray-50 transition-colors">
            <Settings className="h-4 w-4 mr-2" />
            Configuración
          </button>
          <button className="flex items-center justify-center py-3 text-sm text-gray-600 hover:bg-gray-50 transition-colors border-l border-gray-100">
            <ClipboardList className="h-4 w-4 mr-2" />
            Planes
          </button>
        </div>
      </div>
    </div>
  )
}

export default UserProfile

